if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.thumbnailContainer = this.querySelector('.product-media-modal__thumbnails');
        this.bindThumbnailEvents();
        this.setupScrollObserver();
      }

      bindThumbnailEvents() {
        if (!this.thumbnailContainer) return;
        
        // Stop propagation on the entire thumbnail container to prevent modal close
        this.thumbnailContainer.addEventListener('pointerup', (event) => {
          event.stopPropagation();
        });
        this.thumbnailContainer.addEventListener('click', (event) => {
          event.stopPropagation();
        });
        
        // Handle thumbnail clicks
        this.thumbnailContainer.querySelectorAll('.product-media-modal__thumbnail').forEach((button) => {
          button.addEventListener('click', this.onThumbnailClick.bind(this));
        });
      }

      setupScrollObserver() {
        if (!this.thumbnailContainer) return;
        
        const dialog = this.querySelector('.product-media-modal__dialog');
        const content = this.querySelector('.product-media-modal__content');
        if (!dialog || !content) return;

        // Use Intersection Observer to detect which image is visible
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const mediaId = entry.target.getAttribute('data-media-id');
                if (mediaId) {
                  this.updateActiveThumbnail(mediaId);
                }
              }
            });
          },
          {
            root: dialog,
            threshold: 0.5,
          }
        );

        // Observe all media items
        content.querySelectorAll('[data-media-id]').forEach((media) => {
          this.observer.observe(media);
        });
      }

      updateActiveThumbnail(mediaId) {
        if (!this.thumbnailContainer) return;
        
        this.thumbnailContainer.querySelectorAll('.product-media-modal__thumbnail').forEach((thumb) => {
          thumb.classList.remove('active');
        });
        
        const activeThumb = this.thumbnailContainer.querySelector(`.product-media-modal__thumbnail[data-media-id="${mediaId}"]`);
        if (activeThumb) {
          activeThumb.classList.add('active');
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      onThumbnailClick(event) {
        event.preventDefault();
        event.stopPropagation();
        const button = event.currentTarget;
        const mediaId = button.getAttribute('data-media-id');
        this.setActiveMedia(mediaId);
      }

      setActiveMedia(mediaId) {
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;

        // Remove active class from all media and thumbnails
        content.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });
        this.querySelectorAll('.product-media-modal__thumbnail').forEach((thumb) => {
          thumb.classList.remove('active');
        });

        // Find the media element - it could be an img, div, or deferred-media with data-media-id
        const activeMedia = content.querySelector(`[data-media-id="${mediaId}"]`);
        const activeThumb = this.querySelector(`.product-media-modal__thumbnail[data-media-id="${mediaId}"]`);
        
        if (activeMedia) {
          activeMedia.classList.add('active');
          // Scroll to the image
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'start' });
          
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
        
        if (activeThumb) {
          activeThumb.classList.add('active');
          // Scroll thumbnail into view if needed
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        
        // Remove active from all media
        content.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });
        
        // Update thumbnails
        this.querySelectorAll('.product-media-modal__thumbnail').forEach((thumb) => {
          thumb.classList.remove('active');
        });
        const activeThumb = this.querySelector(`.product-media-modal__thumbnail[data-media-id="${mediaId}"]`);
        if (activeThumb) {
          activeThumb.classList.add('active');
        }
        
        const activeMedia = content.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        
        // Scroll to the active media
        activeMedia.scrollIntoView({ block: 'start' });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
